import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import type { JSX } from 'react';

import DateAndTimeV2 from '~pages/Sales/Orders/OrderFormV2/components/DateAndTimeV2';
import CustomAlert from '~pages/Settings/Accounts/ConnectAccountByTreadIdForm/CustomAlert';

import { useOrderFormV3Context } from '../OrderFormV3Context';

/**
 * Renders `form_fields.date_and_time`. Render-only: the embedded
 * DateAndTimeV2 exactly as legacy mounts it (no fork;
 * loadAt/jobStartAt/truckDelay/trucksPerDelay and the same-as-order-start
 * toggle all live inside the embed), plus the past-date advisory alert
 * driven by Provider state (the legacy effect lives in
 * effects/usePastLoadAtWarning.ts). No watch hooks, no flag reads, no effects
 * in this file.
 */
export function DateAndTimePanel(): JSX.Element {
  const { showPastDateWarning } = useOrderFormV3Context();

  return (
    <Card sx={{ p: 2, mb: 2 }}>
      <Typography variant="form-section-title" sx={{ mb: 1 }}>
        {t('form_fields.date_and_time')}
      </Typography>

      <DateAndTimeV2 />

      {showPastDateWarning && (
        <CustomAlert
          message={t('order.form.past_date_warning')}
          variant="error"
          sx={{ mt: 2 }}
        />
      )}
    </Card>
  );
}
